// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"7fdc4be5","436":"0a673a45","453":"f394a27d","501":"e2e40b0e","606":"99a3731d","925":"77cfdf68"}[chunkId] + ".chunk.js";
};